import { createSelector } from "reselect";

export const getData = state => state.app.auth;

export const getUser = createSelector(getData, ({ user = {} }) => user);
